<template>
  <div class="flex flex-col min-h-screen ">
    <component :is="resolvedLayout || 'div'">
      <router-view v-slot="{ Component }">
        <transition
          name="rv"
          mode="out-in"
        >
          <!-- Wrap the routed component in a single element so Transition always has an element root to animate -->
          <div :key="$route.fullPath" class="route-wrapper">
            <!-- Persistent, hidden container for invisible reCAPTCHA so widgets are not tied to transient route DOM -->
            <div id="recaptcha-container" style="display:none" aria-hidden="true" />
            <component :is="Component" />
          </div>
        </transition>
      </router-view>
    </component>
  </div>
</template>
<script>
// import VueMeta from "vue-meta";
import LandingLayout from '@/Layouts/LandingLayout'
import { mapGetters } from 'vuex'
export default {
  components: { LandingLayout },
  data () {
    return {
      connectionStatus: '',
      backtoTop: false
      // buyRestaurentCount: 0
    }
  },
  computed: {
    ...mapGetters({ authenticated: 'authenticated' }),
    resolvedLayout () {
      // If route provides a layout component in meta.layout use it.
      // If meta.layoutCondition is set (string), evaluate it as a Vuex getter name
      // and only use meta.layout when the getter returns truthy. Otherwise fall back to LandingLayout.
      const meta = this.$route && this.$route.meta ? this.$route.meta : {}
      const metaLayout = meta.layout
      const conditionKey = meta.layoutCondition
      if (conditionKey) {
        const cond = this.$store.getters[conditionKey]
        if (cond) return metaLayout || LandingLayout
        return LandingLayout
      }
      return metaLayout || LandingLayout
    }
  },
  mounted () {
    // console.log(this.$route.meta.layout)
    // this.isOnline()
    // this.getDistanceData()
    // this.getDistance({ lat:23.8380339,lng:90.3754975 },{ lat:23.8223486,lng:90.3654204 })

    // console.log(this.connectionStatus)
  },
  methods: {
    isOnline: function () {
      navigator.onLine ? this.connectionStatus = 'Connected to internet.' : this.connectionStatus = 'Unable to connect to internet.'
    },
    getLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const { Latalngs } = this.$store.state.location
          const { latitude, longitude } = position.coords
          Latalngs.device.lat = latitude
          Latalngs.device.lng = longitude
          Latalngs.destination.lat = latitude
          Latalngs.destination.lng = longitude
          // this.showModal = true
          // this.getCurrentLocation(latitude, longitude)
        })
      } else {
        this.location = 'Geolocation is not supported by this browser.'
      }
    }
  }
}
</script>
<style>
.rv-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.rv-enter-active {
  transition: all 0.3s ease-out;
}
.rv-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.rv-leave-active {
  transition: all 0.3s ease-in;
}
</style>
